import { DefaultErrorIProps } from "next/error";

export enum ErrorCode {
  NotFound = 404,
  Error = 500
}

export enum ErrorName {
  NotFound = "NotFound",
  Error = "Error"
}

export interface CustomError extends Partial<DefaultErrorIProps> {
  message: string;
  name: string;
}
